import { render, staticRenderFns } from "./customer-edit.vue?vue&type=template&id=168295a6&scoped=true&"
import script from "./customer-edit.vue?vue&type=script&lang=js&"
export * from "./customer-edit.vue?vue&type=script&lang=js&"
import style0 from "./customer-edit.vue?vue&type=style&index=0&id=168295a6&lang=scss&scoped=true&"
import style1 from "./customer-edit.vue?vue&type=style&index=1&id=168295a6&lang=scss&scoped=true&"
import style2 from "./customer-edit.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168295a6",
  null
  
)

export default component.exports